/* LEOTAC USA — LE Officer Verification Form */
(function() {
  var form = document.getElementById('le-app-form');
  if (!form) return;

  var currentStep = 0;
  var totalSteps = 4;
  var isFederal = false;

  var steps = document.querySelectorAll('.le-app__step');
  var fieldsets = document.querySelectorAll('.le-app__fieldset');
  var errorsEl = document.getElementById('le-app-errors');
  var errorText = document.getElementById('le-app-error-text');
  var deptTypeSelect = document.getElementById('le-dept-type');
  var emailInput = document.getElementById('le-email-input');
  var emailStatus = document.getElementById('le-email-status');
  var emailHint = document.getElementById('le-email-hint');
  var federalNotice = document.getElementById('le-federal-notice');
  var fileInput = document.getElementById('le-file-input');
  var fileLabel = document.getElementById('le-file-label');
  var fileText = document.getElementById('le-file-text');

  function showStep(n) {
    // If federal and going to step 2 (credentials), skip to step 3 (review)
    if (isFederal && n === 2) {
      n = 3;
    }

    currentStep = n;
    fieldsets.forEach(function(fs, i) {
      fs.style.display = i === n ? 'block' : 'none';
    });
    steps.forEach(function(s, i) {
      s.classList.remove('active');
      if (i < n) s.classList.add('completed');
      else s.classList.remove('completed');
      if (i === n) s.classList.add('active');
    });

    // If on review step, populate summary
    if (n === 3) populateReview();

    errorsEl.style.display = 'none';
    window.scrollTo({ top: document.getElementById('le-application').offsetTop - 20, behavior: 'smooth' });
  }

  // Department type change — detect federal
  deptTypeSelect.addEventListener('change', function() {
    isFederal = this.value === 'Federal';
    // Update step 3 label
    if (isFederal) {
      steps[2].textContent = '3. Skipped';
      steps[2].style.textDecoration = 'line-through';
      steps[2].style.opacity = '0.4';
    } else {
      steps[2].textContent = '3. Credentials';
      steps[2].style.textDecoration = '';
      steps[2].style.opacity = '';
    }
  });

  // Email domain validation
  emailInput.addEventListener('input', function() {
    var val = this.value.trim().toLowerCase();
    var domain = val.split('@')[1] || '';

    if (!domain) {
      emailStatus.style.display = 'none';
      emailHint.style.color = '#3A4F6A';
      emailHint.textContent = 'Must be a .gov or .org department email address';
      this.classList.remove('error', 'valid');
      federalNotice.style.display = 'none';
      return;
    }

    var isGov = domain.endsWith('.gov');
    var isOrg = domain.endsWith('.org');

    if (isGov || isOrg) {
      emailStatus.textContent = '\u2713';
      emailStatus.style.color = '#4ADE80';
      emailStatus.style.display = 'block';
      emailHint.style.color = '#4ADE80';
      emailHint.textContent = isGov ? 'Valid .gov email' : 'Valid .org email';
      this.classList.remove('error');
      this.classList.add('valid');

      // Show federal notice if federal + .gov
      if (isFederal && isGov) {
        federalNotice.style.display = 'block';
      } else {
        federalNotice.style.display = 'none';
      }
    } else {
      emailStatus.textContent = '\u2717';
      emailStatus.style.color = '#ff6b6b';
      emailStatus.style.display = 'block';
      emailHint.style.color = '#ff6b6b';
      emailHint.textContent = 'Must be a .gov or .org email address';
      this.classList.remove('valid');
      this.classList.add('error');
      federalNotice.style.display = 'none';
    }
  });

  // File input label update
  fileInput.addEventListener('change', function() {
    if (this.files && this.files[0]) {
      var name = this.files[0].name;
      var size = (this.files[0].size / 1024 / 1024).toFixed(1);
      fileText.textContent = name + ' (' + size + ' MB)';
      fileLabel.classList.add('has-file');
    } else {
      fileText.textContent = 'Choose file...';
      fileLabel.classList.remove('has-file');
    }
  });

  // Step validation
  function validateStep(n) {
    var errors = [];

    if (n === 0) {
      // Department info
      var name = form.querySelector('[name="department_name"]');
      var type = form.querySelector('[name="department_type"]');
      var street = form.querySelector('[name="department_street"]');
      var city = form.querySelector('[name="department_city"]');
      var state = form.querySelector('[name="department_state"]');
      var zip = form.querySelector('[name="department_zip"]');

      [name, type, street, city, state, zip].forEach(function(el) { el.classList.remove('error'); });

      if (!name.value.trim()) { errors.push('Department Name is required'); name.classList.add('error'); }
      if (!type.value) { errors.push('Department Type is required'); type.classList.add('error'); }
      if (!street.value.trim()) { errors.push('Street Address is required'); street.classList.add('error'); }
      if (!city.value.trim()) { errors.push('City is required'); city.classList.add('error'); }
      if (!state.value) { errors.push('State is required'); state.classList.add('error'); }
      if (!zip.value.trim()) { errors.push('ZIP Code is required'); zip.classList.add('error'); }
      else if (!/^\d{5}(-\d{4})?$/.test(zip.value.trim())) { errors.push('Invalid ZIP code format'); zip.classList.add('error'); }
    }

    if (n === 1) {
      // Officer info
      var oName = form.querySelector('[name="officer_name"]');
      var badge = form.querySelector('[name="badge_number"]');
      var email = form.querySelector('[name="department_email"]');

      [oName, badge, email].forEach(function(el) { el.classList.remove('error'); });

      if (!oName.value.trim()) { errors.push('Full Name is required'); oName.classList.add('error'); }
      if (!badge.value.trim()) { errors.push('Badge / ID Number is required'); badge.classList.add('error'); }
      if (!email.value.trim()) { errors.push('Department Email is required'); email.classList.add('error'); }
      else {
        var domain = email.value.trim().toLowerCase().split('@')[1] || '';
        var isGov = domain.endsWith('.gov');
        var isOrg = domain.endsWith('.org');
        if (!isGov && !isOrg) {
          errors.push('Department email must be a .gov or .org address');
          email.classList.add('error');
        }
        if (isFederal && !isGov) {
          errors.push('Federal agents must use a .gov email address');
          email.classList.add('error');
        }
      }
    }

    if (n === 2 && !isFederal) {
      // Credentials (only for non-federal)
      if (!fileInput.files || !fileInput.files[0]) {
        errors.push('Badge or department ID photo is required');
      } else {
        var file = fileInput.files[0];
        if (file.size > 10 * 1024 * 1024) errors.push('File must be under 10MB');
        var ext = file.name.split('.').pop().toLowerCase();
        if (!['pdf', 'jpg', 'jpeg', 'png'].includes(ext)) errors.push('File must be PDF, JPG, or PNG');
      }
      var certActive = document.getElementById('le-certify-active');
      if (!certActive.checked) errors.push('You must certify that you are an active sworn officer');
    }

    return errors;
  }

  // Next buttons
  form.querySelectorAll('.le-app__next').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var nextStep = parseInt(this.getAttribute('data-next'));
      var errors = validateStep(currentStep);
      if (errors.length > 0) {
        errorText.innerHTML = errors.join('<br>');
        errorsEl.style.display = 'block';
        return;
      }
      showStep(nextStep);
    });
  });

  // Back buttons
  form.querySelectorAll('.le-app__back').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var backStep = parseInt(this.getAttribute('data-back'));
      // If federal and going back from review (3) to credentials (2), skip to officer info (1)
      if (isFederal && backStep === 2) backStep = 1;
      showStep(backStep);
    });
  });

  // Populate review summary
  function populateReview() {
    var summary = document.getElementById('le-review-summary');
    var deptType = form.querySelector('[name="department_type"]').value;
    var html = '';

    html += '<div style="margin-bottom:1rem;">';
    html += '<h4 style="color:#5B9BD5; font-family:var(--font-heading); font-size:0.7rem; text-transform:uppercase; letter-spacing:0.1em; margin-bottom:0.5rem;">Department</h4>';
    html += '<p style="color:#D4D4D8; font-size:0.85rem; margin:0;">' + esc(form.querySelector('[name="department_name"]').value) + '</p>';
    html += '<p style="color:#6B82A0; font-size:0.8rem; margin:0.2rem 0 0;">' + esc(deptType) + '</p>';
    html += '<p style="color:#6B82A0; font-size:0.8rem; margin:0.2rem 0 0;">';
    html += esc(form.querySelector('[name="department_street"]').value) + ', ';
    html += esc(form.querySelector('[name="department_city"]').value) + ', ';
    html += esc(form.querySelector('[name="department_state"]').value) + ' ';
    html += esc(form.querySelector('[name="department_zip"]').value);
    html += '</p></div>';

    html += '<div style="margin-bottom:1rem;">';
    html += '<h4 style="color:#5B9BD5; font-family:var(--font-heading); font-size:0.7rem; text-transform:uppercase; letter-spacing:0.1em; margin-bottom:0.5rem;">Officer</h4>';
    html += '<p style="color:#D4D4D8; font-size:0.85rem; margin:0;">' + esc(form.querySelector('[name="officer_name"]').value) + '</p>';
    var rank = form.querySelector('[name="rank_title"]').value;
    if (rank) html += '<p style="color:#6B82A0; font-size:0.8rem; margin:0.2rem 0 0;">' + esc(rank) + '</p>';
    html += '<p style="color:#6B82A0; font-size:0.8rem; margin:0.2rem 0 0;">Badge #' + esc(form.querySelector('[name="badge_number"]').value) + '</p>';
    html += '<p style="color:#6B82A0; font-size:0.8rem; margin:0.2rem 0 0;">' + esc(form.querySelector('[name="department_email"]').value) + '</p>';
    html += '</div>';

    html += '<div>';
    html += '<h4 style="color:#5B9BD5; font-family:var(--font-heading); font-size:0.7rem; text-transform:uppercase; letter-spacing:0.1em; margin-bottom:0.5rem;">Verification</h4>';
    if (isFederal) {
      html += '<p style="color:#4ADE80; font-size:0.8rem; margin:0;">Federal agent — .gov email verification (no credential upload required)</p>';
    } else {
      var fileName = fileInput.files && fileInput.files[0] ? fileInput.files[0].name : 'None';
      html += '<p style="color:#D4D4D8; font-size:0.8rem; margin:0;">Credential uploaded: ' + esc(fileName) + '</p>';
    }
    html += '</div>';

    summary.innerHTML = html;
  }

  function esc(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  // Form submission
  form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Final validation
    var certFinal = document.getElementById('le-certify-final');
    if (!certFinal.checked) {
      errorText.textContent = 'You must certify that all information is accurate';
      errorsEl.style.display = 'block';
      return;
    }

    var submitBtn = document.getElementById('le-app-submit');
    var submitText = document.getElementById('le-app-submit-text');
    var submitLoading = document.getElementById('le-app-submit-loading');
    submitBtn.disabled = true;
    submitText.style.display = 'none';
    submitLoading.style.display = 'inline-flex';

    var fd = new FormData();
    fd.append('officer_name', form.querySelector('[name="officer_name"]').value.trim());
    fd.append('rank_title', form.querySelector('[name="rank_title"]').value.trim());
    fd.append('badge_number', form.querySelector('[name="badge_number"]').value.trim());
    fd.append('department_email', form.querySelector('[name="department_email"]').value.trim());
    fd.append('phone', (form.querySelector('[name="phone"]').value || '').trim());
    fd.append('department_name', form.querySelector('[name="department_name"]').value.trim());
    fd.append('department_type', form.querySelector('[name="department_type"]').value);
    fd.append('department_street', form.querySelector('[name="department_street"]').value.trim());
    fd.append('department_city', form.querySelector('[name="department_city"]').value.trim());
    fd.append('department_state', form.querySelector('[name="department_state"]').value);
    fd.append('department_zip', form.querySelector('[name="department_zip"]').value.trim());
    fd.append('certify', 'true');

    // Only append file for non-federal
    if (!isFederal && fileInput.files && fileInput.files[0]) {
      fd.append('credential_file', fileInput.files[0]);
    }

    var apiUrl = window.LEOTAC_LE_API || '#';

    fetch(apiUrl + '/api/officer/apply', {
      method: 'POST',
      body: fd
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.success) {
        document.getElementById('le-app-form').style.display = 'none';
        document.querySelector('.le-app__steps').style.display = 'none';
        document.getElementById('le-app-success').style.display = 'block';
        document.getElementById('le-app-success-msg').textContent = data.message || 'Your verification has been approved. Check your email to set up your account.';
        if (data.application_id) {
          document.getElementById('le-app-id').textContent = 'Application ID: ' + data.application_id;
        }
      } else {
        errorText.innerHTML = (data.errors || ['An error occurred']).join('<br>');
        errorsEl.style.display = 'block';
        submitBtn.disabled = false;
        submitText.style.display = 'inline';
        submitLoading.style.display = 'none';
      }
    })
    .catch(function() {
      errorText.textContent = 'Network error. Please check your connection and try again.';
      errorsEl.style.display = 'block';
      submitBtn.disabled = false;
      submitText.style.display = 'inline';
      submitLoading.style.display = 'none';
    });
  });
})();
